import React, { useEffect, useState } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader, Surface, Text } from '@/components/flup';
import BasicDetailsForm from '@/components/profile/vendorProfile/BasicDetailsForm';
import AddressForm from '@/components/profile/vendorProfile/AddressForm';
import BankDetailsTabForm from '@/components/profile/vendorProfile/BankDetailsTabForm';
import { getVendorProfile } from '@/store/thunkMidddleware/usersMiddleware';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import { useNavigate } from "react-router-dom";
import { RootState } from '@/store';
import BasicDetailsFormSkeleton from '@/components/skeletons/BasicDetailsFormSkeleton';

const Profile = () => {
    const navigate = useNavigate()

    const dispatch = useAppDispatch();
    const authState = useAppSelector(state => state.auth)
    const profileState = useAppSelector(state => state.profile)

    const { loginMethod, loading, error } = useAppSelector((state: RootState) => state.auth);

    const fetchProfile = async (token?: string) => {
        dispatch(getVendorProfile({
            callback: (profile) => {
                console.log("profile:", profile)
                if (profile?.payload?.vendorProfileCompleted) {
                    // navigate(routes.dashboard)
                } else {
                    // navigate(routes.vendorOnboard)

                }
                console.log("getVendorProfile:", profile)
            }
        }))
    }
    useEffect(() => {
        fetchProfile()
    }, [])



    if (profileState.vendorProfile.isLoading) {
        return <BasicDetailsFormSkeleton />
    }





    return (
        <div className="max-w-3xl space-y-4">
            <PageHeader
                title="Profile"
                subtitle="Your personal details, address, and where payouts land."
            />

            <Surface padding="p-5">
                <Tabs defaultValue="basicdetails">
                    <TabsList className="grid w-full grid-cols-3 mb-6">
                        <TabsTrigger value="basicdetails">Basic details</TabsTrigger>
                        <TabsTrigger value="Address">Address</TabsTrigger>
                        <TabsTrigger value="BankAccount">Bank account</TabsTrigger>
                    </TabsList>

                    <TabsContent value="basicdetails" className="space-y-4">
                        <SectionIntro
                            title="Basic information"
                            description="Your name and how customers and our team reach you."
                        />
                        <BasicDetailsForm />
                    </TabsContent>

                    <TabsContent value="Address" className="space-y-4">
                        <SectionIntro
                            title="Address"
                            description="Used for verification and on your invoices."
                        />
                        <AddressForm />
                    </TabsContent>

                    <TabsContent value="BankAccount" className="space-y-4">
                        <SectionIntro
                            title="Bank account"
                            description="Where your settlements are paid out. Double-check these — a wrong digit delays every payout."
                        />
                        <BankDetailsTabForm />
                    </TabsContent>
                </Tabs>
            </Surface>
        </div>
    )
}

/** Heading + one line of context above each tab's form. */
const SectionIntro: React.FC<{ title: string; description: string }> = ({ title, description }) => (
    <div className="pb-4 mb-2 border-b border-flup-hairline">
        <Text variant="h3" as="h2">{title}</Text>
        <Text variant="caption" tone="secondary" as="p" className="mt-1">{description}</Text>
    </div>
);

export default Profile